import * as apiGetSettingKey from 'api/setting/GetSettingV1';
import { ReducerBuilder } from 'reducers/ReducerBuilder';
import { payloadReducer } from 'reducers/reducerUtils';

export type AutoCompleteLanguagesType = string[];

export async function getAutoCompleteLanguagesFromApi(): Promise<AutoCompleteLanguagesType> {
	// const response = await apiGetSettingKey.callApi();
	// return response.map((x) => x.recipeSettings.autoCompleteLanguages).getOrDefault([]);
	return [];
}

const rb = new ReducerBuilder<AutoCompleteLanguagesType>();
export const autoCompleteLanguagesLoadedAction = rb.createActionForReducer(
	payloadReducer((x) => x),
	'AutoCompleteLanguages/LoadedFromBackend'
);

export const autoCompleteLanguagesReducer = rb.createReducer();
